import { render, staticRenderFns } from "./virus19.vue?vue&type=template&id=a734517c&scoped=true&"
import script from "./virus19.vue?vue&type=script&lang=js&"
export * from "./virus19.vue?vue&type=script&lang=js&"
import style0 from "./virus19.vue?vue&type=style&index=0&id=a734517c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a734517c",
  null
  
)

export default component.exports